export const getCurrentDate = function() {
  const e = new Date().getFullYear()
  const s = e - 4
  return { s, e }
}